import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { BaseService } from './base-service';
import { UserService } from './user-service';

import { API_TIMEOUT } from './config';

@Injectable()
export class SubscriptionService extends BaseService {

  constructor(public http: Http, public userService: UserService) {
    super();
    console.log('Hello SubscriptionService Provider');
  }

  podcasts() {
    const userId = this.userService.authData.userId;
    const url = `${super.url()}/users/${userId}/podcasts`;
    const headers = { headers: this.userService.getAuthorizationHeaders() };
    // fetching podcasts
    return this.http.get(url, headers).timeout(API_TIMEOUT).map(res => {
      const data = res.json();
      // sorting by publishedAt before returning
      data.data.sort(function(a,b){
        return new Date(b.latestEpisodePublishedAt).getTime() - new Date(a.latestEpisodePublishedAt).getTime();
      });
      return data.data;
    });
  }

  unsubscribe(podcastId) {
    const userId = this.userService.authData.userId;
    // need subscriptionId
    return this.subscriptionId(userId, podcastId)
      .flatMap((subscriptionId: string) => {
        const url = `${super.url()}/subscriptions/${subscriptionId}`;
        const headers = { headers: this.userService.getAuthorizationHeaders() };
        // removing subscription to podcast
        return this.http.delete(url, headers).timeout(API_TIMEOUT)
          .flatMap(res => Observable.of(res.json()))
          .catch(this.handleError);
    });
  }

  subscribe(podcastId) {
    const _user = this.userService.authData.userId;
    const _podcast = podcastId;
    const url = `${super.url()}/subscriptions/`;
    const params = { _user, _podcast };
    const headers = { headers: this.userService.getAuthorizationHeaders() };
    return this.http.post(url, params, headers).timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  subscriptionId(userId, podcastId) {
    const url = `${super.url()}/subscriptions/match/${userId}/${podcastId}`;
    const headers = { headers: this.userService.getAuthorizationHeaders() };
    return this.http.get(url, headers).timeout(API_TIMEOUT).map(res => {
      const data = res.json();
      return data._id; // TODO: THIS API SHOULD RETURN DATA: OBJ NOT THE OBJ DIRECTLY
    })
    .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/subscription-service.ts